import { IScope } from 'angular';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import { MobileSellerAPIConfig } from '../../../src/app/@shared-types/api/mobile-de';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

/* @ngInject */
export default class MobileSellerAPIController {
  private $scope: IScope;

  public mobileSellerConfig: MobileSellerAPIConfig | null = null;

  private settingsApiService: SettingsAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  constructor(
    $scope: IScope,
    settingsApiService: SettingsAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
  ) {
    this.settingsApiService = settingsApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;

    // load API configurations. If request fails, the tenant is not allowed to use this API.
    this.getMobileSellerConfig();
  }

  private getMobileSellerConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<MobileSellerAPIConfig[]>(EExternalAPI.MOBILE_SELLER).catch();

    [this.mobileSellerConfig] = configs;
    this.interfaceService.applyScope(this.$scope);
  };

  public updateConfig = (
    apiId: string,
    config: unknown,
  ): Promise<void> => {
    (config as MobileSellerAPIConfig).accounts.forEach((a) => {
      a.quota.ads = parseInt(String(a.quota.ads), 10);
      a.quota.highlights = 0;
    });

    return this.settingsApiService.updateAPIConfig(apiId as EExternalAPI, config)
      .then(() => this.toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert.'));
  };
}
